const TECHNICAL_SUPPORT_SERVICE_ID = 5;
const SHOWROOM_SERVICE_ID = 4;
const DELIVERY_SERVICE_GROUP_ID = 1;
var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["STANDARD"] = "Standard";
    DeliveryMethod["SHOWROOM"] = "Showroom";
})(DeliveryMethod || (DeliveryMethod = {}));
var DeliveryType;
(function (DeliveryType) {
    DeliveryType["DOMESTIC"] = "DELIVERY_TYPE_AT_HOME";
    DeliveryType["SHOWROOM"] = "DELIVERY_TYPE_PICKUP";
    DeliveryType["HANDOVER"] = "DELIVERY_TYPE_HANDOVER";
})(DeliveryType || (DeliveryType = {}));
var DeliveryTimeSlotType;
(function (DeliveryTimeSlotType) {
    DeliveryTimeSlotType["REQUIRED"] = "REQUIRED";
    DeliveryTimeSlotType["OPTIONAL"] = "OPTIONAL";
    DeliveryTimeSlotType["NONE"] = "NONE";
})(DeliveryTimeSlotType || (DeliveryTimeSlotType = {}));

export { DELIVERY_SERVICE_GROUP_ID, DeliveryMethod, DeliveryTimeSlotType, DeliveryType, SHOWROOM_SERVICE_ID, TECHNICAL_SUPPORT_SERVICE_ID };
